module.exports = __webpack_public_path__ + "static/media/icon-pdf.00edf2f7.svg";